import { render, staticRenderFns } from "./FarmsList.vue?vue&type=template&id=47b5c513&scoped=true"
import script from "./FarmsList.vue?vue&type=script&lang=js"
export * from "./FarmsList.vue?vue&type=script&lang=js"
import style0 from "./FarmsList.vue?vue&type=style&index=0&id=47b5c513&lang=scss&scoped=true"
import style1 from "./FarmsList.vue?vue&type=style&index=1&id=47b5c513&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b5c513",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b5c513')) {
      api.createRecord('47b5c513', component.options)
    } else {
      api.reload('47b5c513', component.options)
    }
    module.hot.accept("./FarmsList.vue?vue&type=template&id=47b5c513&scoped=true", function () {
      api.rerender('47b5c513', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/farm/components/FarmsList.vue"
export default component.exports